import { httpClient } from "./httpClient";

const getAllInstitute = () => {
  return httpClient.get("institute");
};

export default {
  getAllInstitute,
};
